// Profile 섹션 헤더 (목업 .sec-h 재현) — 블루 5px 마커 + 아이브로우 라벨 (+ 우측 집계 고지).
import type { ReactNode } from 'react'

interface Props {
  label: string
  /** 우측 정렬 집계 고지 1줄(소스·집계창·기준일). 없으면 기존과 동일한 헤더. */
  note?: ReactNode
  /** 라벨 바로 옆 ⓘ 슬롯(InfoTip) — 선정/집계 기준 노출용. 없으면 기존과 동일한 헤더. */
  info?: ReactNode
}

export function SectionHeader({ label, note, info }: Props) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-x-2 gap-y-1">
      <span className="inline-block h-[5px] w-[5px] flex-none bg-brand-blue" aria-hidden />
      <span className="font-text text-[11px] font-medium tracking-[0.16em] text-fg-3">{label}</span>
      {info}
      {note && (
        <span className="ml-auto break-keep font-text text-[11px] normal-case tracking-normal text-fg-3">
          {note}
        </span>
      )}
    </div>
  )
}
